
import { Routes, Route } from "react-router-dom";
import MainLayout from "../pages/layouts/mainLayout";
import Home from "../pages/home";
import Services from "../pages/services";
import AboutUs from "../pages/about";
import ContactUs from "../pages/contact";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
      </Route>
    </Routes>
  );
};

export default Router;